import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PersonalProfileStep = ({ formData, errors, onChange }) => {
  const ageOptions = Array.from({ length: 15 }, (_, i) => ({
    value: (i + 12)?.toString(),
    label: `${i + 12} ans`
  }));

  const genderOptions = [
    { value: 'male', label: 'Masculin' },
    { value: 'female', label: 'Féminin' },
    { value: 'other', label: 'Autre' }
  ];

  const regionOptions = [
    { value: 'dakar', label: 'Dakar' },
    { value: 'thies', label: 'Thiès' },
    { value: 'saint-louis', label: 'Saint-Louis' },
    { value: 'kaolack', label: 'Kaolack' },
    { value: 'ziguinchor', label: 'Ziguinchor' },
    { value: 'diourbel', label: 'Diourbel' },
    { value: 'louga', label: 'Louga' },
    { value: 'tambacounda', label: 'Tambacounda' },
    { value: 'kolda', label: 'Kolda' },
    { value: 'matam', label: 'Matam' },
    { value: 'kaffrine', label: 'Kaffrine' },
    { value: 'kedougou', label: 'Kédougou' },
    { value: 'sedhiou', label: 'Sédhiou' },
    { value: 'fatick', label: 'Fatick' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-blue-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">1</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Informations Personnelles
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Commençons par quelques informations de base pour personnaliser votre expérience.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
        <Input
          label="Prénom"
          type="text"
          name="firstName"
          placeholder="Entrez votre prénom"
          value={formData?.firstName}
          onChange={onChange}
          error={errors?.firstName}
          required
        />

        <Input
          label="Nom de Famille"
          type="text"
          name="lastName"
          placeholder="Entrez votre nom"
          value={formData?.lastName}
          onChange={onChange}
          error={errors?.lastName}
          required
        />
      </div>
      <Input
        label="Adresse Email"
        type="email"
        name="email"
        placeholder="exemple@email.com"
        description="Nous utiliserons cette adresse pour vous envoyer vos résultats"
        value={formData?.email}
        onChange={onChange}
        error={errors?.email}
        required
      />
      <Input
        label="Numéro de Téléphone"
        type="tel"
        name="phone"
        placeholder="+221 XX XXX XX XX"
        description="Format: +221 suivi de votre numéro"
        value={formData?.phone}
        onChange={onChange}
        error={errors?.phone}
        required
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
        <Input
          label="Mot de Passe"
          type="password"
          name="password"
          placeholder="Minimum 6 caractères"
          value={formData?.password}
          onChange={onChange}
          error={errors?.password}
          required
        />

        <Input
          label="Confirmer le Mot de Passe"
          type="password"
          name="confirmPassword"
          placeholder="Retapez votre mot de passe"
          value={formData?.confirmPassword}
          onChange={onChange}
          error={errors?.confirmPassword}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
        <Select
          label="Âge"
          options={ageOptions}
          value={formData?.age}
          onChange={(value) => onChange({ target: { name: 'age', value } })}
          placeholder="Sélectionnez votre âge"
          error={errors?.age}
          required
        />

        <Select
          label="Genre"
          options={genderOptions}
          value={formData?.gender}
          onChange={(value) => onChange({ target: { name: 'gender', value } })}
          placeholder="Sélectionnez votre genre"
          error={errors?.gender}
          required
        />
      </div>
      <Select
        label="Région de Résidence"
        options={regionOptions}
        value={formData?.region}
        onChange={(value) => onChange({ target: { name: 'region', value } })}
        placeholder="Sélectionnez votre région"
        description="Cela nous aide à vous recommander des écoles proches"
        error={errors?.region}
        searchable
        required
      />
    </div>
  );
};

export default PersonalProfileStep;